module.exports = __webpack_public_path__ + "img/check-blue.e9e5b7fd.svg";